import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import settings from "../../settings";
import Logger from "../../models/Logger";
import FetchResponses from "../../models/FetchResponses";
import {
  translateDetails,
} from "../../models/Messages";
import FacturaView from "./FacturaView";
import Navbar from "./Navbar";
import NavbarV2 from "./NavbarV2";


//Public views
class FacturasPublicas extends Component {
  constructor(props) {
      super(props);
      this.state = {
        clientInvoices:{},
        carteraCastigada:false,
        listMenu: []
      };
      Logger.setLogger(this.constructor.name);
    }

  componentDidMount() {
    this.getListMenu()
    this.setState({
      loading: true
    });
    if(this.props.location.state){
      let clientInvoices =this.props.location.state.clientInvoices
      let carteraCastigada=this.props.location.state.carteraCastigada
      this.setState({clientInvoices,carteraCastigada})
    }

  }


  getListMenu = () => {
    //it brings all the sections to be rendered 
    let url = settings.backend.listMenu;

    fetch(url, {
      method: "GET"
    }).then(FetchResponses.processResponse)
      .then((response) => {
        if (response) {
          this.setState({
            listMenu: response
          });
        }
      })
      .catch(this.failureDataResponse);
  }

  render() {
    if(this.props.location.state){
      return <>
      {/* <Navbar mainpage/> */}
      <NavbarV2 mainpage listMenu={this.state.listMenu}/>
      <FacturaView 
        clientInvoices={this.state.clientInvoices} 
        loading={this.state.loading} 
        carteraCastigada={this.state.carteraCastigada}
        publicView
      />
      </>
    }else{
      return <Redirect to={'/'}/>
    }
      
  }
    
}

export default FacturasPublicas